let isUnloading = false;

/** True once an in-app hard navigation has been initiated. */
export const isPageUnloading = () => isUnloading;

export const markPageUnloading = () => {
  isUnloading = true;
};

/**
 * Full-document navigation. Requests still in flight are aborted by the browser and
 * surface as generic network errors; marking the page as unloading first lets the API
 * result pipeline and route guards ignore those non-failures.
 */
export const hardNavigateTo = (url: string) => {
  markPageUnloading();
  window.location.href = url;
};
